import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rolesAPI } from '../../services/api';

export const fetchRoles = createAsyncThunk('roles/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await rolesAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to load roles'); }
});

export const createRole = createAsyncThunk('roles/create', async (data, { rejectWithValue }) => {
  try { const res = await rolesAPI.create(data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to create role'); }
});

export const updateRole = createAsyncThunk('roles/update', async ({ id, data }, { rejectWithValue }) => {
  try { const res = await rolesAPI.update(id, data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to update role'); }
});

export const deleteRole = createAsyncThunk('roles/delete', async (id, { rejectWithValue }) => {
  try { await rolesAPI.delete(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to delete role'); }
});

const rolesSlice = createSlice({
  name: 'roles',
  initialState: {
    items: [],
    allPermissions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.roles;
        state.allPermissions = action.payload.permissions || [];
      })
      .addCase(fetchRoles.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createRole.fulfilled, (state, action) => {
        state.items.push(action.payload.role);
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        const idx = state.items.findIndex(r => r._id === action.payload.role._id);
        if (idx !== -1) state.items[idx] = action.payload.role;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.items = state.items.filter(r => r._id !== action.payload);
      });
  },
});

export default rolesSlice.reducer;
